/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import ProfileTab from 'containers/Organizations/SingleOrganization/Profiles/SingleProfile/ProfileTab';

const ProfileDashboard = props => {
  return <ProfileTab {...props} />;
};

export default ProfileDashboard;
